import { CONTACTS_CRUD_ACTION_CONSTANTS } from '../actions/contacts_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['contactsIndex']);
export default standardReducerGenerator(CONTACTS_CRUD_ACTION_CONSTANTS, initialState, 'email');
